//export const BASE_URL = "http://localhost/sbi-backend/"
export const BASE_URL = "https://api-sbi.work/"
